/**
 * Store Mock 数据（对齐 api-contract.md StoreDTO）
 */

import type { ApiResponse, PageData } from '../../../types/common';
import type {
  Store,
  PageStoreRequest,
  PageStoreData,
} from '../../../types/master-data/store';
import { StoreFormat, StoreStatus } from '../../../types/master-data/store';

/**
 * Mock 门店数据
 */
const mockStores: Store[] = [
  // Fresh 门店
  {
    id: 1,
    code: 'GF001',
    storeCode: 'GF001',
    storeName: 'Fresh Downtown',
    englishName: 'Fresh Downtown',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '123 Sukhumvit Road',
    area: 500,
    storeFormat: StoreFormat.FRESH,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1743408000000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  {
    id: 2,
    code: 'GF002',
    storeCode: 'GF002',
    storeName: 'Fresh Midtown',
    englishName: 'Fresh Midtown',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '456 Asoke Road',
    area: 450,
    storeFormat: StoreFormat.FRESH,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1743321600000,
    modifierAccount: 'john.doe',
    modifierName: 'John Doe',
  },
  {
    id: 3,
    code: 'GF003',
    storeCode: 'GF003',
    storeName: 'Fresh Uptown',
    englishName: 'Fresh Uptown',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '789 Rama 9 Road',
    area: 600,
    storeFormat: StoreFormat.FRESH,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: Date.now(),
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  {
    id: 4,
    code: 'GF004',
    storeCode: 'GF004',
    storeName: 'Fresh Riverside',
    englishName: 'Fresh Riverside',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '101 Silom Road',
    area: 380,
    storeFormat: StoreFormat.FRESH,
    status: StoreStatus.INACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1743235200000,
    modifierAccount: 'jane.smith',
    modifierName: 'Jane Smith',
  },
  {
    id: 5,
    code: 'GF005',
    storeCode: 'GF005',
    storeName: 'Fresh Central',
    englishName: 'Fresh Central',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '202 Sathorn Road',
    area: 520,
    storeFormat: StoreFormat.FRESH,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1743148800000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  // Supermarket 门店
  {
    id: 6,
    code: 'SM001',
    storeCode: 'SM001',
    storeName: 'Supermart Plaza',
    englishName: 'Supermart Plaza',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '303 Phahonyothin Road',
    area: 1200,
    storeFormat: StoreFormat.SUPERMARKET,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1743062400000,
    modifierAccount: 'mike.wilson',
    modifierName: 'Mike Wilson',
  },
  {
    id: 7,
    code: 'SM002',
    storeCode: 'SM002',
    storeName: 'Supermart Mall',
    englishName: 'Supermart Mall',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '404 Vibhavadi Rangsit Road',
    area: 1500,
    storeFormat: StoreFormat.SUPERMARKET,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: Date.now(),
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  {
    id: 8,
    code: 'SM003',
    storeCode: 'SM003',
    storeName: 'Supermart Square',
    englishName: 'Supermart Square',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '505 Ratchadaphisek Road',
    area: 1100,
    storeFormat: StoreFormat.SUPERMARKET,
    status: StoreStatus.INACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742976000000,
    modifierAccount: 'sarah.lee',
    modifierName: 'Sarah Lee',
  },
  {
    id: 9,
    code: 'SM004',
    storeCode: 'SM004',
    storeName: 'Supermart Center',
    englishName: 'Supermart Center',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '606 Sri Ayutthaya Road',
    area: 1300,
    storeFormat: StoreFormat.SUPERMARKET,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: Date.now(),
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  {
    id: 10,
    code: 'SM005',
    storeCode: 'SM005',
    storeName: 'Supermart Hub',
    englishName: 'Supermart Hub',
    state: 'Bangkok',
    city: 'Bangkok',
    address: '707 Phetchaburi Road',
    area: 1400,
    storeFormat: StoreFormat.SUPERMARKET,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742889600000,
    modifierAccount: 'david.kim',
    modifierName: 'David Kim',
  },
  // Hyper 门店
  {
    id: 11,
    code: 'HP001',
    storeCode: 'HP001',
    storeName: 'Hyper Mega Store',
    englishName: 'Hyper Mega Store',
    state: 'Chonburi',
    city: 'Pattaya',
    address: '100 Sukhumvit Road, Pattaya',
    area: 5000,
    storeFormat: StoreFormat.HYPER,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742803200000,
    modifierAccount: 'emma.chen',
    modifierName: 'Emma Chen',
  },
  {
    id: 12,
    code: 'HP002',
    storeCode: 'HP002',
    storeName: 'Hyper Giant Mart',
    englishName: 'Hyper Giant Mart',
    state: 'Chiang Mai',
    city: 'Chiang Mai',
    address: '200 Super Highway, Chiang Mai',
    area: 4500,
    storeFormat: StoreFormat.HYPER,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: Date.now(),
    modifierAccount: 'admin',
    modifierName: 'Admin User',
  },
  {
    id: 13,
    code: 'HP003',
    storeCode: 'HP003',
    storeName: 'Hyper Super Center',
    englishName: 'Hyper Super Center',
    state: 'Phuket',
    city: 'Phuket',
    address: '300 Chaofa Road, Phuket',
    area: 4800,
    storeFormat: StoreFormat.HYPER,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742716800000,
    modifierAccount: 'lisa.wang',
    modifierName: 'Lisa Wang',
  },
  {
    id: 14,
    code: 'HP004',
    storeCode: 'HP004',
    storeName: 'Hyper World',
    englishName: 'Hyper World',
    state: 'Khon Kaen',
    city: 'Khon Kaen',
    address: '400 Mittraphap Road, Khon Kaen',
    area: 5500,
    storeFormat: StoreFormat.HYPER,
    status: StoreStatus.INACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742630400000,
    modifierAccount: 'tom.brown',
    modifierName: 'Tom Brown',
  },
  {
    id: 15,
    code: 'HP005',
    storeCode: 'HP005',
    storeName: 'Hyper Land',
    englishName: 'Hyper Land',
    state: 'Nakhon Ratchasima',
    city: 'Nakhon Ratchasima',
    address: '500 Suranarai Road, Korat',
    area: 6000,
    storeFormat: StoreFormat.HYPER,
    status: StoreStatus.ACTIVE,
    gmtCreate: Date.now(),
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtModified: 1742544000000,
    modifierAccount: 'peter.zhang',
    modifierName: 'Peter Zhang',
  },
];

/**
 * Mock 工具函数 - 成功响应 (符合 domain-frontend-spec 规范)
 */
function mockSuccess<T>(data: T): ApiResponse<T> {
  return {
    traceId: `mock-${Date.now()}`,
    success: true,
    errorMessage: null,
    flag: 'success',
    data,
  };
}

/**
 * Mock 工具函数 - 分页成功响应 (符合 domain-frontend-spec 规范)
 */
function mockPageSuccess<T>(
  tableData: T[],
  totalCount: number,
  currentPage: number,
  pageSize: number
): ApiResponse<PageData<T>> {
  return mockSuccess({
    tableData,
    paging: {
      currentPage,
      totalCount,
      pageSize,
    },
  });
}

/**
 * Mock 工具函数 - 错误响应 (符合 domain-frontend-spec 规范)
 */
function mockError(errorMessage: string): ApiResponse<null> {
  return {
    traceId: `mock-${Date.now()}`,
    success: false,
    errorMessage,
    flag: 'fail',
    data: null,
  };
}

/**
 * Mock 分页查询门店 (符合 domain-frontend-spec 规范)
 */
export function mockPageStores(
  params: PageStoreRequest
): Promise<ApiResponse<PageStoreData>> {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filteredData = [...mockStores];

      // keyword 统一模糊搜索（OR 匹配 storeCode / storeName / englishName）
      const keyword = (params as any).keyword;
      if (keyword && keyword.trim()) {
        const kw = keyword.trim().toLowerCase();
        filteredData = filteredData.filter((store) =>
          store.storeCode.toLowerCase().includes(kw) ||
          store.storeName.toLowerCase().includes(kw) ||
          (store.englishName && store.englishName.toLowerCase().includes(kw))
        );
      } else {
        // 单字段模糊筛选（AND 关系）
        if (params.storeCode) {
          filteredData = filteredData.filter((store) =>
            store.storeCode.toLowerCase().includes(params.storeCode!.toLowerCase())
          );
        }
        if (params.storeName) {
          filteredData = filteredData.filter((store) =>
            store.storeName.toLowerCase().includes(params.storeName!.toLowerCase())
          );
        }
      }
      if (params.storeFormat) {
        filteredData = filteredData.filter((store) => store.storeFormat === params.storeFormat);
      }
      if (params.status) {
        filteredData = filteredData.filter((store) => store.status === params.status);
      }

      // 分页
      const totalCount = filteredData.length;
      const start = (params.currentPage - 1) * params.pageSize;
      const end = start + params.pageSize;
      const tableData = filteredData.slice(start, end);

      resolve(mockPageSuccess(tableData, totalCount, params.currentPage, params.pageSize));
    }, 300);
  });
}

/**
 * Mock 获取门店列表 (符合 domain-frontend-spec 规范)
 */
export function mockListStores(
  params?: Partial<Store>
): Promise<ApiResponse<Store[]>> {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filteredData = [...mockStores];

      // 根据参数过滤
      if (params?.storeCode) {
        filteredData = filteredData.filter((store) => store.storeCode === params.storeCode);
      }
      if (params?.storeName) {
        filteredData = filteredData.filter((store) =>
          store.storeName.includes(params.storeName!)
        );
      }
      if (params?.status) {
        filteredData = filteredData.filter((store) => store.status === params.status);
      }

      resolve(mockSuccess(filteredData));
    }, 300);
  });
}

/**
 * Mock 获取门店详情
 */
export function mockGetStore(id: number): Promise<ApiResponse<Store>> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const store = mockStores.find((w) => w.id === id);
      if (!store) {
        resolve(mockError('门店不存在'));
        return;
      }

      resolve(mockSuccess(store));
    }, 300);
  });
}
